import { ChevronLeft, ChevronRight } from 'lucide-react'
import { DayPicker } from 'react-day-picker'
import 'react-day-picker/style.css'
import { cn } from '@/lib/utils'

export type CalendarProps = React.ComponentProps<typeof DayPicker>

export function Calendar({ className, classNames, showOutsideDays = true, ...props }: CalendarProps) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3', className)}
      classNames={{
        month: 'space-y-4 relative',
        month_caption: 'flex justify-center pt-1 items-center h-8',
        caption_label: 'text-sm font-medium',
        nav: 'contents',
        button_previous:
          'absolute left-1 top-1 z-10 inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-accent hover:text-accent-foreground',
        button_next:
          'absolute right-1 top-1 z-10 inline-flex h-7 w-7 items-center justify-center rounded-md hover:bg-accent hover:text-accent-foreground',
        month_grid: 'w-full border-collapse',
        weekdays: 'flex',
        weekday: 'text-muted-foreground rounded-md w-9 text-[0.8rem] font-normal',
        week: 'flex w-full mt-2',
        day: 'h-9 w-9 text-center text-sm p-0 relative rounded-md focus-within:relative focus-within:z-20',
        day_button:
          'h-9 w-9 p-0 font-normal rounded-md hover:bg-accent hover:text-accent-foreground aria-selected:bg-primary aria-selected:text-primary-foreground aria-selected:hover:bg-primary aria-selected:hover:text-primary-foreground data-[today=true]:bg-accent/50',
        selected: 'bg-primary text-primary-foreground',
        today: 'bg-accent/50 text-accent-foreground',
        outside: 'text-muted-foreground opacity-50',
        disabled: 'text-muted-foreground opacity-40',
        hidden: 'invisible',
        ...classNames,
      }}
      components={{
        Chevron: ({ orientation, className: iconClass }) =>
          orientation === 'left' ? (
            <ChevronLeft className={cn('h-4 w-4', iconClass)} />
          ) : (
            <ChevronRight className={cn('h-4 w-4', iconClass)} />
          ),
      }}
      {...props}
    />
  )
}
